(() => {
  /* ===============================
     Detection
     =============================== */

  const PRODUCTS_READY_SELECTOR =
    '.seller_product_grid .product-block-div, .wk-product-card, .wk_mp_product, .product-grid, [data-product-id]';

  const SELLER_CARD_SELECTOR =
    '.mp-seller-grid.sellers, [id^="seller_"], .wk-vendor-card, .wk-seller-card, .wk_mp_seller_card, .mp-seller, .seller-card, [data-seller-id]';

  const PRODUCT_GRID_HOST_SELECTOR =
    '.seller_product_grid, .col-md-9.col-lg-9.col-sm-9.col-xs-12, .col-md-12.mp-margin-top-15';

  const productsAreReady = () => !!document.querySelector('#seller_product_tab')?.querySelector(PRODUCTS_READY_SELECTOR);

  // Webkul renders an explicit empty result after the request completes.
  // An empty response is ready too; absence of cards alone is not enough.
  function getEmptyProductResult() {
    const grid = document.querySelector('#seller_product_tab .seller_product_grid');
    if (!grid || grid.querySelector(PRODUCTS_READY_SELECTOR)) return null;
    return Array.from(grid.children).find(el =>
      el.dataset.hoskayEmptyProducts === 'true' ||
      /^No Products? Found[.!\s]*$/i.test(el.textContent.trim())
    ) || null;
  }

  function showEmptyProducts(empty) {
    const bg = document.documentElement.lang.toLowerCase().startsWith('bg');
    const title = bg ? 'Няма продукти за показване' : 'No products to display';
    if (empty.dataset.hoskayEmptyProducts === 'true' && empty.querySelector('h2')?.textContent === title) return;
    empty.dataset.hoskayEmptyProducts = 'true';
    empty.setAttribute('role', 'status');
    empty.style.cssText = 'width:100%;padding:48px 20px;text-align:center;color:#4b5c52';
    const heading = document.createElement('h2');
    heading.textContent = title;
    heading.style.cssText = 'font-size:22px;line-height:1.4;margin:0 0 16px';
    const link = document.createElement('a');
    link.href = bg ? '/collections/all' : '/en/collections/all';
    link.textContent = bg ? 'Разгледай всички продукти →' : 'Explore all products →';
    link.style.cssText = 'display:inline-block;color:inherit;text-decoration:underline;text-underline-offset:3px';
    empty.replaceChildren(heading, link);
  }
  const sellerCardsExist = () => !!document.querySelector(SELLER_CARD_SELECTOR);
  const getProductGridHost = () => document.querySelector(PRODUCT_GRID_HOST_SELECTOR);

  function getKind() {
    if (/^\/(?:[a-z]{2}(?:-[A-Za-z]{2})?\/)?pages\/seller-profile\/?$/.test(location.pathname) && location.search.length > 1) {
      return 'profile';
    }
    return 'list';
  }

  function profileHeaderIsReady() {
    const root = document.querySelector('.mp_sp_page');
    if (!root) return false;

    const nameEl = root.querySelector('.mp-store-name');
    const logoEl = root.querySelector('#shop_logo_image');
    const ownerEl = root.querySelector('.wk-seller-profile');

    const hasName = !!(nameEl && nameEl.textContent && nameEl.textContent.trim().length > 0);
    const hasLogo = !!(
      logoEl &&
      logoEl.getAttribute('src') &&
      logoEl.getAttribute('src').trim() &&
      !/No-Image/i.test(logoEl.getAttribute('src'))
    );
    const hasOwner = !!(ownerEl && ownerEl.textContent && ownerEl.textContent.trim().length > 0);

    return hasName && (hasLogo || hasOwner);
  }

  /* ===============================
     Shared skeleton styles
     =============================== */

  function ensureSharedSkeletonStyle(target = document.head) {
    if (document.getElementById('wk-skeleton-shared-style')) return;

    const style = document.createElement('style');
    style.id = 'wk-skeleton-shared-style';
    style.textContent = `
      .wk-skel-b{
        position:relative;
        overflow:hidden;
        background:rgba(75,92,82,.10);
      }

      .wk-skel-b::after{
        content:"";
        position:absolute;
        inset:0;
        transform:translateX(-100%);
        background:linear-gradient(
          90deg,
          rgba(255,255,255,0) 0%,
          rgba(255,255,255,.58) 50%,
          rgba(255,255,255,0) 100%
        );
        animation:wkShimmer 1.2s infinite;
      }

      @keyframes wkShimmer{
        100%{ transform:translateX(100%); }
      }
    `;
    target.appendChild(style);
  }

  /* ===============================
     Full-page skeleton for loader
     =============================== */

  function ensureLoaderSkeleton(loader) {
    if (!loader || loader.querySelector('[data-wk-skeleton]')) return;

    ensureSharedSkeletonStyle();
    const kind = getKind();

    const wrap = document.createElement('div');
    wrap.setAttribute('data-wk-skeleton', 'true');

    if (kind === 'list') {
      wrap.style.cssText = `
        max-width:1100px;
        margin:34px auto 60px;
        padding:0 16px;
        display:grid;
        grid-template-columns:repeat(4,minmax(0,1fr));
        gap:30px 18px;
      `;

      for (let i = 0; i < 8; i++) {
        const card = document.createElement('div');
        card.style.cssText = `
          display:flex;
          flex-direction:column;
          align-items:center;
          text-align:center;
        `;

        card.innerHTML = `
          <div class="wk-skel-b" style="width:118px;height:118px;border-radius:50%;margin-bottom:16px;"></div>
          <div class="wk-skel-b" style="width:68%;height:16px;border-radius:999px;margin-bottom:12px;"></div>
          <div class="wk-skel-b" style="width:42%;height:12px;border-radius:999px;"></div>
        `;
        wrap.appendChild(card);
      }

      const resp = document.createElement('style');
      resp.textContent = `
        @media (max-width:991px){
          [data-wk-skeleton]{
            grid-template-columns:repeat(3,minmax(0,1fr))!important;
            gap:26px 16px!important;
          }
        }
        @media (max-width:767px){
          [data-wk-skeleton]{
            grid-template-columns:repeat(2,minmax(0,1fr))!important;
            gap:24px 14px!important;
            padding:0 12px!important;
            margin-top:22px!important;
          }
        }
      `;
      wrap.appendChild(resp);
    } else {
      wrap.className="hk-shop-skeleton";
      wrap.innerHTML=`
        <div class="wk-skel-b hk-shop-skel-banner"></div>
        <div class="hk-shop-skel-head"><div class="wk-skel-b hk-shop-skel-logo"></div><div class="wk-skel-b hk-shop-skel-title"></div><div class="wk-skel-b hk-shop-skel-about"></div></div>
        <div class="wk-skel-b hk-shop-skel-sort"></div>
        <div id="wk-skel-products-preview">${Array.from({length:6},()=>'<div><div class="wk-skel-b" style="aspect-ratio:1;border-radius:8px;margin-bottom:10px"></div><div class="wk-skel-b" style="height:14px;width:85%;margin-bottom:8px"></div><div class="wk-skel-b" style="height:14px;width:40%"></div></div>').join('')}</div>
        <style>
        .hk-shop-skeleton{max-width:1120px;margin:32px auto 40px;padding:0 16px;box-sizing:border-box}.hk-shop-skel-banner{height:160px;border-radius:8px}.hk-shop-skel-head{display:grid;grid-template-columns:128px minmax(0,1fr);gap:12px 24px;align-items:center;margin:-36px 0 12px;position:relative}.hk-shop-skel-logo{width:128px;height:128px;border-radius:50%;border:4px solid #fff;box-sizing:border-box}.hk-shop-skel-title{height:32px;width:min(260px,90%);border-radius:4px;margin-top:36px}.hk-shop-skel-about{grid-column:1 / -1;height:40px;width:78%;border-radius:4px}.hk-shop-skel-sort{width:44px;height:44px;border-radius:50%;margin:0 0 16px auto}#wk-skel-products-preview{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:28px 20px}@media(max-width:767px){.hk-shop-skeleton{margin-top:0;padding:0 4px;max-width:100%}.hk-shop-skel-banner{height:135px;border-radius:0;width:100vw;margin-inline:calc(50% - 50vw)}.hk-shop-skel-head{grid-template-columns:104px minmax(0,1fr);gap:4px 14px;margin:-36px 0 0}.hk-shop-skel-logo{width:104px;height:104px}.hk-shop-skel-title{height:25px;width:min(200px,92%)}.hk-shop-skel-about{height:16px;width:90px;margin-block:10px}.hk-shop-skel-sort{margin:-40px 0 0 auto}#wk-skel-products-preview{grid-template-columns:repeat(2,minmax(0,1fr));gap:16px 6px}}@media(prefers-reduced-motion:reduce){.wk-skel-b:after{animation:none!important}}
        </style>`;
    }

    loader.appendChild(wrap);
  }

  /* ===============================
     Products-only skeleton for profile
     =============================== */

  function ensureProfileProductsSkeleton() {
    if (getKind() !== 'profile') return;
    if (productsAreReady() || getEmptyProductResult()) return;

    const host = getProductGridHost();
    if (!host) return;
    if (host.querySelector('[data-wk-products-skeleton]')) return;

    ensureSharedSkeletonStyle();

    const wrap = document.createElement('div');
    wrap.setAttribute('data-wk-products-skeleton', 'true');
    wrap.style.cssText = `
      display:grid;
      grid-template-columns:repeat(3,minmax(0,1fr));
      gap:28px 20px;
      margin-top:16px;
      width:100%;
    `;

    wrap.innerHTML = `
      ${Array.from({ length: 6 }).map(() => `
        <div style="display:flex;flex-direction:column;">
          <div class="wk-skel-b" style="width:100%;aspect-ratio:1 / 1;border-radius:8px;margin-bottom:10px;"></div>
          <div class="wk-skel-b" style="height:14px;border-radius:999px;margin-bottom:10px;"></div>
          <div class="wk-skel-b" style="height:14px;width:44%;border-radius:999px;"></div>
        </div>
      `).join('')}
      <style>
        @media (max-width:991px){
          [data-wk-products-skeleton]{
            grid-template-columns:repeat(2,minmax(0,1fr))!important;
          }
        }
        @media (max-width:767px){
          [data-wk-products-skeleton]{
            grid-template-columns:repeat(2,minmax(0,1fr))!important;
            gap:16px 6px!important;
            margin-top:0!important;
          }
        }
      </style>
    `;

    host.appendChild(wrap);
  }

  function removeProfileProductsSkeleton() {
    document.querySelectorAll('[data-wk-products-skeleton]').forEach(el => el.remove());
  }

  /* ===============================
     Loader handling
     =============================== */

  function hideLoader(loader) {
    if (!loader || loader.dataset.wkHiding === '1') return;
    loader.dataset.wkHiding = '1';
    loader.style.opacity = '0';
    loader.style.transition = 'opacity 160ms ease';
    setTimeout(() => {
      if (loader && loader.parentNode) loader.remove();
    }, 180);
  }

  function prepLoader(loader) {
    if (!loader) return;
    loader.querySelectorAll('.mp-spinner, .title-text').forEach(el => el.remove());
    if(getKind()==='profile'){const header=document.getElementById('header-group');loader.style.top=Math.max(0,header?header.getBoundingClientRect().bottom:0)+'px';loader.style.overflowY='auto';}
    loader.style.background = 'rgba(255,255,255,0.92)';
    loader.style.backdropFilter = 'blur(6px)';
    loader.style.zIndex = '1100';
  }

  function fixLoader() {
    const loader = document.querySelector('.mp-loader');
    const kind = getKind();

    if (loader) {
      prepLoader(loader);
    }

    if (kind === 'list') {
      if (loader) ensureLoaderSkeleton(loader);

      if (sellerCardsExist()) {
        if (loader) hideLoader(loader);
        return;
      }
    }

    if (kind === 'profile') {
      if (!profileHeaderIsReady()) {
        if (loader) ensureLoaderSkeleton(loader);
        return;
      }

      if (loader) hideLoader(loader);

      const empty = getEmptyProductResult();
      if (productsAreReady() || empty) {
        removeProfileProductsSkeleton();
        if (empty) showEmptyProducts(empty);
      } else {
        ensureProfileProductsSkeleton();
      }
      return;
    }

    if (kind === 'profile' && productsAreReady()) {
      removeProfileProductsSkeleton();
    }
  }

  /* ===============================
     Observe async Webkul rendering
     =============================== */

  let safetyTimerStarted = false;

  function startSafetyTimer() {
    if (safetyTimerStarted) return;
    safetyTimerStarted = true;

    setTimeout(() => {
      const loader = document.querySelector('.mp-loader');
      if (loader) loader.remove();
    }, 12000);
  }

  const obs = new MutationObserver(() => {
    fixLoader();
    startSafetyTimer();
  });

  obs.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', () => {
    fixLoader();
    startSafetyTimer();
  });

  window.addEventListener('load', () => {
    fixLoader();
    setTimeout(fixLoader, 250);
    setTimeout(fixLoader, 800);
  });
})();
/* Localise third-party interface labels; product and customer content is untouched. */
(function () {
  if (!/^bg(?:-|$)/i.test(document.documentElement.lang)) return;
  const labels = new Map(Object.entries({
    'Seller Products':'Продукти','Feedback':'Отзиви','Policy':'Условия','Extra Info':'Допълнителна информация','SHOP OWNER':'Собственик на магазина','Sort by:':'Подреди по:',
    'Name Ascending':'Име: А–Я','Name Descending':'Име: Я–А','Date Ascending':'Първо най-старите','Date Descending':'Първо най-новите','Price Ascending':'Цена: ниска към висока','Price Descending':'Цена: висока към ниска',
    'reviews':'отзива','review':'отзив','Bulgaria':'България','Reviews':'Отзиви','Click to review':'Напиши отзив','Star rating':'Оценка със звезди','No reviews yet, lead the way and share your thoughts':'Все още няма отзиви. Сподели първото мнение.',
    'Feedback Summary':'Заглавие на отзива','Feedback submitted':'Отзивът е изпратен','Feedback submitted for approval':'Отзивът е изпратен за одобрение'
  }));
  function translate() {
    const main = document.querySelector('main'); if (!main) return;
    const walker = document.createTreeWalker(main, NodeFilter.SHOW_TEXT);
    let node; while ((node = walker.nextNode())) {
      const el = node.parentElement;
      if (!el || !el.closest('.mp_sp_page,#seller_country_origin_div,[class*="AirReviews-"]') || el.closest('script,style,textarea,input,[contenteditable="true"],.AirReviews-ReviewItem')) continue;
      const source = node.nodeValue; const text = source.trim();
      let value = labels.get(text);
      if (!value && /^Seller Origin Country\s*-/.test(text)) value = text.replace(/^Seller Origin Country\s*-\s*/, 'Държава на продавача: ').replace(/Bulgaria$/, 'България');
      if (!value && /^Join Since /.test(text)) { value = text.replace(/^Join Since /, 'В Hoskay от '); const months=['January','February','March','April','May','June','July','August','September','October','November','December'];const bg=['януари','февруари','март','април','май','юни','юли','август','септември','октомври','ноември','декември'];months.forEach((m,i)=>{value=value.replace(m,bg[i]);}); }
      if (!value && /^\d+ reviews?$/.test(text)) value = text.replace(/reviews?$/, Number(text.split(' ')[0]) === 1 ? 'отзив' : 'отзива');
      if (value && value !== text) node.nodeValue = source.replace(text,value);
    }
  }
  let queued = false;
  const observer = new MutationObserver(() => { if (queued) return; queued=true; requestAnimationFrame(()=>{queued=false;translate();}); });
  observer.observe(document.documentElement,{childList:true,subtree:true,characterData:true});
  document.addEventListener('DOMContentLoaded',translate); translate();
})();
